export const HOME_PAGE_CONTENT_TYPE = 'blog_landing_page'
export const HOME_PAGE_URL = '/'

export const SHARED_BANNER_MODAL = 'shared_banner_modal';
export const ECOM_PROMOTIONS = 'ecom_promotions';



export const homePageIncludeReference = [
  'body.banner.banner_reference',
  'body.featured_post.blog_post',
  'body.featured_post.blog_post.blog_snippet.category',
  'body.featured_post.blog_post.blog_snippet.topic_tags',
  'body.featured_post.blog_post.blog_snippet.product_tags',
  'body.category_cards.categories',
  'body.category_cards.categories.category_reference',
  'body.category_cards.categories.category_reference.label',
  'body.category_cards.categories.category_reference.subtitle',
  'body.category_cards.categories.category_reference.description',
  'body.search_bar.hot_topics',
  'body.banner.banner_reference',
  'body.carousel.carousel',
  'body.carousel.carousel.carousel_title',
  'body.carousel.carousel.articles.article'
];

export const otherHomePageReference = [
  'body.verticle_blog_list.blog_post',
  'body.verticle_blog_list.blog_post.blog_snippet.category',
  'body.verticle_blog_list.blog_post.blog_snippet.category.category_reference',
  'body.verticle_blog_list.blog_post.blog_snippet.topic_tags',
  'body.verticle_blog_list.blog_post.blog_snippet.product_tags',
  'body.hot_articles.hot_articles',
  'body.hot_articles.hot_articles.articles.article',
  'body.hot_articles.hot_articles.articles.article.blog_snippet.category',
  'body.hot_articles.hot_articles.articles.article.blog_snippet.topic_tags',
  'body.hot_articles.hot_articles.articles.article.blog_snippet.product_tags',
  'latestArticles.blog_snippet.category',
  'latestArticles.blog_snippet.category.category_reference',
  'latestArticles.blog_snippet.topic_tags',
  'latestArticles.blog_snippet.product_tags'
]

export const headerAndFooterIncludeReference = [
  'header',
  'footer',
  'header.country_list',
  'footer.country_list',
  'header.navigation_sections.ecom_promotion_ref.ecommerce_promotion_reference',
];
